import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_STATICS = "fetchCompanyStatics";

// mutation types
export const SET_COMPANY_STATICS = "setCompanyStatics";

const state = {
  companyStatics: []
};

const getters = {
  companyStatics(state) {
    return state.companyStatics;
  }
};

const actions = {
  [FETCH_COMPANY_STATICS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("company/statics")
        .then(({ data }) => {
          context.commit(SET_COMPANY_STATICS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANY_STATICS](state, payload) {
    state.companyStatics = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
